import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'standing by'
	}
});

export default app;